
import { Options, Vue } from "vue-class-component";
import Navigation from "@/components/Navigation.vue"; // @ is an alias to /src
import Header from "./components/Header.vue";
import Disclaimer from "./components/Disclaimer.vue";

@Options({
  created: function () {
    if (!localStorage.getItem("project-id")) {
      localStorage.setItem("project-id", "0");
      localStorage.setItem("projects", JSON.stringify({}));
    }
  },
  components: {
    Navigation,
    // Modal,
    Header,
    Disclaimer,
  },
  data: function () {
    return {
      consent: false,
    };
  },
  mounted: function () {
    this.consent = !!localStorage.getItem("consent");
  },
  methods: {
    closeWalletModal: function () {
      this.$store.commit("closeWalletModal");
    },
    setConsent: function () {
      localStorage.setItem("consent", "true");
      this.consent = true;
    },
  },
  computed: {
    walletModalIsActive: function () {
      return this.$store.state.walletModalActive;
    },
  },
})
export default class App extends Vue {}
